import React from 'react';
import Toolbar from '../../components/Toolbar';
import {RxForm, FormManager, FormRow} from 'reactis-forms';
import {TextInput, Number} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ButtonToolbar from '../../components/ButtonToolbar';

@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)};
	}, null, {withRef: true })
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);

		this.api = {
			fetch: 'qsection.fetch',
			save: 'qsection.save',
			remove: 'qsection.delete'
		};

		this.changeEvent = 'qsection.change';

		this.messages = {
			remove: 'Opravdu si přejete oblast odstranit?',
			notfound: 'Oblast nenalezena!'
		};

		this.schema = {
			title: {
				class: TextInput,
				label: 'Název',
				autoFocus: !props.id,
				rules: {
					presence: {message: 'Název je povinná položka!'}
				}
			},
			priority: {
				class: Number,
				label: 'Pořadí',
			},
			fortest: {
				class: Number,
				label: 'Otázek do testu',
				rules: {
					presence: {message: 'Zadejte počet otázek!'}
				}
			},
			points: {
				class: Number,
				label: 'Počet bodů',
				rules: {
				  presence: {message: 'Zadejte počet bodů!'}
				}
			},
		};
		this.form = new FormManager(this.schema);
	}

	componentDidMount() {
		this.form.on('change', (key, value) => {
			if (key == 'title') {
				this.title = value;
			}
			this.changed = true;
		});
		super.componentDidMount();
	}

	updateTab(data) {
		this.props.updateTab({title: data.title});
	}

	render() {

		const loading = !!(this.props.form && this.props.form.get('saving'));
		const canEdit = true || this.user.isAllowed('user', 'update');
		const canDelete = true || this.user.isAllowed('user', 'delete');
		const isNew = !this.props.id;

		const saveCloseButton = <LoadingButton
			disabled={!canEdit}
			title="Uložit"
			loading={loading}
			onClick={()=>this.save(true)}
		/>;

		const toolbar = [
			{
				title: 'Uložit',
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'primary',
				onClick: () => this.save(true)
			},
			{
				title: 'Uložit a pokračovat v editaci',
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'default',
				onClick: () => this.save()
			},
			{
				title: 'Uložit a nový',
				icon: 'fa fa-file-o',
				loading: loading,
				bsStyle: 'default',
				onClick: ()=>this.save(true, false, {}, () => this.props.newTab())
			},
			{
				divider: true
			},
			{
				title: 'Odstranit',
				icon: 'fa fa-trash-o',
				bsStyle: 'danger',
				color: '#A00',
				onClick: ()=>this.remove()
			}
		];

		return (
			<div style={{position:'relative'}}>
				<Loader visible={!!(this.props.form && this.props.form.get('loading'))} />
				<RxForm ref="form" form={this.form} id={'tab_' + this.props.tabid}>
					<Toolbar title="Oblast">
						<ButtonToolbar buttons={toolbar} />
					</Toolbar>
					<div className="row">
						<div>
							<table className="form">
								<tbody>
								{Object.keys(this.schema).map((key) => {
									return <FormRow key={key} visible={this.schema[key].visible} name={key} labelWidth={160}/>
								})}
								<FormRow className="buttons">
									{saveCloseButton}
								</FormRow>
								</tbody>
							</table>
						</div>
					</div>
				</RxForm>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Qsection/Form.js